<template>
  <div class="friend">
    <div class="top_backdrop">
      <div class="content">
        <div class="title">
          恭喜您获得
          <span></span>
          <span></span>
        </div>
        <div class="integral">
          <span>30</span> 积分
        </div>
      </div>
      <div class="form">
        <div class="phone">
          <span class="icon"></span>
          <input type="text" placeholder="输入手机号领取积分" v-model="form.mobile" maxlength="11" />
        </div>
        <div class="auth-code">
          <span class="icon"></span>
          <input type="text" placeholder="验证码" v-model="form.code" />
          <div class="button" :class="{'ban': isSending}" @click="getAuthCode">{{code_text}}</div>
        </div>
        <div class="explain">点击即代表同意使用该手机号码注册</div>
      </div>
      <div class="submit" @click="submit"></div>
      <div class="logo"></div>
      <m-modal :show="modal" @shutdown="onshutdown">
        <div class="focus" v-if="!show">
          <div class="logo-title">
            <div class="mlogo"></div>成功领取30积分
          </div>
          <img src="./images/qrcode_for_gh.png" class="code" />
          <div class="title">
            关注“
            <span>智慧银河Service</span>”公众号
          </div>
          <div class="describe">查询办理进度、领积分兑好礼</div>
        </div>
        <div class="success" v-else>
          <img src="./images/successfully.png" />
          <div class="title">恭喜您，成功领取<span>30</span>积分</div>
          <div class="describe">
           超值好礼等你来兑
          </div>
          <div class="button" @click="$router.push('/home')">前往积分商城</div>
        </div>
      </m-modal>
    </div>
  </div>
</template>
<script>
import { setRegisteruser, sendmsg } from "../../../api/api-config";
import MModal from "../../../components/Mmodal";
export default {
  props: {},
  data() {
    return {
      form: {
        mobile: "",
        code: "",
        parent_client_id: ""
      },
      code_text: "获取验证码",
      second: 59,
      isSending: false,
      modal: false,
      show: false
    };
  },
  computed: {},
  created() {
    let clientId = this._getUrlParam("client_id");
    if (clientId) {
      this.form.parent_client_id = clientId;
    }
  },
  mounted() {},
  watch: {},
  methods: {
    onshutdown() {
      this.modal = false;
    },
    async getAuthCode() {
      if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        this.$toast("手机号格式不正确！");
        return;
      }
      this._countDown();
      const res = await sendmsg(this.form.mobile);
      const data = res.data;
      if (data.code === 200) {
        this.$toast("验证码已发送");
      } else {
        this.$toast(data.msg);
      }
    },
    async submit() {
      if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        this.$toast("手机号格式不正确！");
        return;
      }
      if (!this.form.code) {
        this.$toast("验证码不能为空");
        return;
      }
      console.log(this.form);
      const res = await setRegisteruser(this.form);
      const data = res.data;
      if (data.code === 200) {
        this.modal = true
        if(data.data.is_care === "1") {
           this.show = true
        }
      } else {
        this.$toast(data.msg);
      }
    },
    _countDown() {
      this.isSending = true;
      const timer = setInterval(() => {
        if (this.second === 0) {
          this.second = 59;
          this.code_text = "获取验证码";
          this.isSending = false;
          clearInterval(timer);
        } else {
          this.second--;
          this.code_text = this.second + "s重新获取";
        }
      }, 1000);
    },
    _getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return decodeURI(r[2]);
      return null; //返回参数值
    }
  },
  components: {
    MModal
  }
};
</script>

<style scoped lang="scss">
.friend {
  background: #331fd1;
  min-height: 100%;
  .top_backdrop {
    width: 100%;
    height: rem(1342);
    background: url("./images/Point reward.png") no-repeat;
    background-size: 100% rem(1342);
    position: relative;
    .content {
      position: absolute;
      top: rem(318);
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      .title {
        font-size: rem(26);
        color: #f92817;
        position: relative;
        & > span {
          display: inline-block;
          width: rem(36);
          height: rem(2);
          background: #d82607;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        & > span:nth-of-type(1) {
          left: rem(0);
        }
        & > span:nth-of-type(2) {
          right: rem(0);
        }
        &:before {
          content: "";
          display: inline-block;
          width: rem(7);
          height: rem(7);
          border-radius: 50%;
          background: #fb2a0f;
          vertical-align: middle;
          margin-right: rem(10);
          margin-top: rem(-7);
        }
        &:after {
          content: "";
          display: inline-block;
          width: rem(7);
          height: rem(7);
          border-radius: 50%;
          background: #fb2a0f;
          vertical-align: middle;
          margin-left: rem(10);
          margin-top: rem(-7);
        }
      }
      .integral {
        font-size: rem(28);
        color: #f92817;
        line-height: rem(140);
        & > span {
          font-size: rem(132);
          font-weight: 800;
        }
      }
    }
    .form {
      position: absolute;
      top: rem(598);
      left: 50%;
      transform: translateX(-50%);
      .phone,
      .auth-code {
        width: rem(564);
        height: rem(98);
        border-radius: rem(44);
        overflow: hidden;
        position: relative;
        & > .icon {
          width: rem(50);
          height: rem(50);

          position: absolute;
          top: rem(24);
          left: rem(38);
        }
        & > input {
          width: 100%;
          height: 100%;
          padding-left: rem(100);
          box-sizing: border-box;
          font-size: rem(30);
          color: #999;
        }
      }
      .phone {
        margin-bottom: rem(40);
        & > .icon {
          background: url("./images/phone.png") no-repeat;
          background-size: rem(50) rem(50);
        }
      }
      .auth-code {
        & > .icon {
          background: url("./images/Verification_code.png") no-repeat;
          background-size: rem(50) rem(50);
        }
        & > .button {
          width: rem(187);
          height: rem(98);
          background: #fbe3cb;
          font-size: rem(28);
          color: #a33211;
          text-align: center;
          line-height: rem(98);
          position: absolute;
          top: 0;
          right: 0;
        }
        & > .ban {
          pointer-events: none;
          background: #ddd;
          color: #fff;
        }
      }
      .explain {
        font-size: rem(24);
        color: #fff;
        text-align: center;
        margin-top: rem(48);
      }
    }
    .submit {
      width: rem(660);
      height: rem(178);
      background: url("./images/receive.png") no-repeat;
      background-size: rem(660) rem(178);
      position: absolute;
      top: rem(909);
      left: 50%;
      transform: translateX(-50%);
    }
    .logo {
      width: rem(690);
      height: rem(150);
      background: url("../../../assets/images/slogen.png") no-repeat;
      background-size: rem(690) rem(150);
      position: absolute;
      top: rem(1160);
      left: 50%;
      transform: translateX(-50%);
    }
    .focus {
      .logo-title {
        width: rem(440);
        height: rem(120);
        background: rgba(255, 243, 224, 1);
        border-radius: rem(80);
        font-size: rem(34);
        color: #000;
        margin: 0 auto;
        & > .mlogo {
          display: inline-block;
          width: rem(120);
          height: rem(120);
          background: url("./images/successfully.png") no-repeat;
          background-size: rem(120) rem(120);
          margin-left: rem(20);
          vertical-align: middle;
        }
      }
      .code {
        display: block;
        width: rem(274);
        height: rem(274);
        margin: rem(40) auto;
      }
      .title {
        font-size: rem(34);
        font-weight: 800;
        color: #333;
        text-align: center;
        & > span {
          color: #126fee;
        }
      }
      .describe {
        font-size: rem(28);
        color: #999;
        text-align: center;
        padding: rem(30) 0;
      }
    }
    .success {
      & > img {
        display: block;
        width: rem(168);
        height: rem(168);
        margin: 0 auto;
      }
      .title {
        font-size: rem(38);
        font-weight: 800;
        color: #333;
        text-align: center;
        & > span {
          color: #ff6d00;
        }
      }
      .describe {
        font-size: rem(28);
        color: #999;
        text-align: center;
        padding: rem(40) 0;
      }
      .button {
        width: rem(460);
        height: rem(98);
        background: linear-gradient(to right, #3386ff, #245df7);
        border-radius: rem(50);
        font-size: rem(34);
        color: #fff;
        text-align: center;
        line-height: rem(98);
        margin: 0 auto;
      }
    }
  }
}
</style>
